import ArchiveIcon from '@mui/icons-material/Archive'
import AudiotrackIcon from '@mui/icons-material/Audiotrack'
import CodeIcon from '@mui/icons-material/Code'
import DescriptionIcon from '@mui/icons-material/Description'
import ImageIcon from '@mui/icons-material/Image'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import MovieIcon from '@mui/icons-material/Movie'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'

export function getIconByMimetype(mimetype: string) {
  if (!mimetype) return <InsertDriveFileIcon />

  if (mimetype.startsWith('image/')) return <ImageIcon />
  if (mimetype === 'application/pdf') return <PictureAsPdfIcon />
  if (mimetype.startsWith('video/')) return <MovieIcon />
  if (mimetype.startsWith('audio/')) return <AudiotrackIcon />
  if (mimetype.includes('word')) return <DescriptionIcon />
  if (mimetype.includes('text')) return <TextSnippetIcon />
  if (mimetype.includes('zip') || mimetype.includes('rar'))
    return <ArchiveIcon />
  if (
    mimetype.includes('json') ||
    mimetype.includes('javascript') ||
    mimetype.includes('xml')
  )
    return <CodeIcon />

  return <InsertDriveFileIcon />
}
